<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-card class="pa-2" outlined tile height="100%">
        <v-data-table
          :headers="headers"
          :items="cases"
          sort-by="StartDate"
          sort-desc
          :loading="isLoading"
          loading-text="Loading Case Management"
          :search="search"
          height="550"
          
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Case Management</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                clearable
                @click:clear="callItBack()"
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="desktop"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="100%">
                <template v-slot:activator="{ on }">
                  <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                >
                <v-icon left>add</v-icon>
                Add Case Management</v-btn
              >
                </template>
                <v-card>
                  <v-card-title style="background-color: #2b3990">
                    <span class="headline white--text">{{ titleForm }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form
                      ref="form"
                      lazy-validation
                    >
                    <v-container>
                      <v-row>
                          <v-col cols="12" md="4">
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="newDate"
                                  label="Date of Service"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="newDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu.save(newDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4">
                              <v-select
                                  :items="times"
                                  label="Duration of Service Provided"
                                  v-model="newTime"
                                  :rules="requiredField"
                              ></v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-select
                                label="Select Location"
                                :items="locations"
                                v-model="newLocation"
                                :rules="requiredField"
                              ></v-select>
                          </v-col>
                          <v-col cols="12">
                              <v-select
                                  label="Select Code"
                                  :items="codes"
                                  v-model="newCode"
                                  :rules="requiredField"
                              ></v-select>
                          </v-col>
                          
                          <v-col cols="12">
                            <v-textarea
                              label="Add Service Provided Description"
                              v-model="newServiceProvided"
                              :rules="requiredField"
                              outlined
                            ></v-textarea>
                          </v-col>
                          
                      </v-row>
                    </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="white--text"
                      color="#259647"
                      @click="addCase()"
                      v-if="newCase"
                      >Save</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="updateCase()"
                      v-if="editCase"
                      >Update</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancel</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
            <v-text-field
              v-model="search"
              clearable
              flat
              solo-inverted
              hide-details
              prepend-inner-icon="search"
              label="search"
              class="mobile ml-5 mr-5 mb-3 mt-3"
            ></v-text-field>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="viewCase(item)">
              mdi-eye
            </v-icon>
            <!-- <v-icon small class="mr-2" @click="editCase(item)">
          mdi-pencil
        </v-icon> -->
            <v-icon small @click="deleteCase(item)">
              mdi-delete
            </v-icon>
            <!-- <v-icon small @click="addDeal(item)">
          add
        </v-icon> -->
          </template>
          <template v-slot:no-data>
            <v-btn color="#2b3990" class="white--text" @click="getCases()">Reset</v-btn>
          </template>
        </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import moment from "moment";

const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "Date",
        },
        { text: "Time", value: "Time"},
        { text: "Code", value: "Code"},
        { text: "Location", value: "Location" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      dialog: false,
      editCase: false,
      newCase: false,
      msg: false,
      search: "",
      text: "",
      cases: [],
      tempData: [],
      clientID: this.$route.params.clientID,
      titleForm: "New Case Management",
      caseManagementID: "",
      newDate: "",
      newTime: "",
      newCode: "",
      newLocation: "",
      newServiceProvided: "",
      codes: [
        "1.    Assist person to develop personal goals.",
        "2.    Schedule/attend ISP meeting and other informational meetings.",
        "3.    Develop Habilitation/Support Plans & train staff on plans and data collection.",
        "4.    Assist person to apply for and obtain community resources and benefits (e.g.: housing; food stamps, Medicaid, etc.)",
        "5.    Assist person to locate residence.",
        "6.    Assist in arranging and managing generic community resources and informal supports.",
        "7.    Assist in identifying and sustaining natural support networks, network of family, friends and associates.",
        "8.    Provide problem solving and support with crisis management.",
        "9.    Support person with budgeting, bill paying and with scheduling and keeping appointments.",
        "10.  Observe, coach, train and provide feedback of waiver services provided by direct & support services staff.",
        "11.  Follow-up with Health/Welfare concerns and remediation with deficiencies",
        "12.  Complete required paperwork on behalf of the person served.",
        "13.  Make home visits to observe the person’s living environment to assure health, and welfare",
        "14.  Provide information to Service Coordinator to allow for evaluation and assurance of support services provided in ISP.",

      ],
      locations: [
        "H - Home",
        "O - Office",
        "W - Work",
        "S - School",
        "P - Phone",
        "T - Other"
      ],
      times: [
        .25,
        .50,
        .75,
        1.00,
        1.25,
        1.50,
        1.75,
        2.00,
        2.25,
        2.50,
        2.75,
        3.00,
        3.25,
        3.50,
        3.75,
        4.00,
        4.25,
        4.50,
        4.75,
        5.00,
        5.25,
        5.50,
        5.75,
        6.00,
        6.25,
        6.50,
        6.75,
        7.00,
        7.25,
        7.50,
        7.75,
        8.00,
        8.25,
        8.50,
        8.75,
        9.00,
        9.25,
        9.50,
        9.75,
        10.00,

      ],
      requiredField: [
          v => !!v || 'This is required',
      ],

      isLoading: true,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getCases();
  },

  methods: {
    initialize() {
      this.cases = [];
    },
    validate() {
        return this.$refs.form.validate();
    },
    viewCase(item) {
      this.titleForm = "Viewing Case Management Record"
      this.dialog = true;
      this.editCase = true;
      this.newCase = false;
      this.newDate = item.Date;
      this.newTime = item.Time;
      this.newCode = item.Code;
      this.newLocation = item.Location;
      this.newServiceProvided = item.ServiceProvided;
      this.caseManagementID = item._id;
    },
    showAdd() {
      this.titleForm = "New Case Management";
      this.newCase = true;
      this.editCase = false;
    },

    deleteCase(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this case management record?") &&
        this.caseDelete(id);
    },

    caseDelete(id) {
      axios.delete(`${url}/caseManagement/${id}`).then((response) => {
        this.getCases();
        if (response.status == 400) {
          response.json().then(function(data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The record has been deleted successfully.";
      });
    },

    close() {
      this.clear()
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateCase() {
      var req_body = {
        Date: this.newDate,
        Time: this.newTime,
        Code: this.newCode,
        Location: this.newLocation,
        ServiceProvided: this.newServiceProvided,
      };
      axios
        .put(`${url}/caseManagement/${this.caseManagementID}`, req_body)
        .then((response) => {
          this.getCases();
          if (response.status == 400) {
            response.json().then(function(data) {
              alert(data.msg);
            });
          }
          this.clear()
          this.msg = true;
          this.text = "The record has been updated successfully.";
        });
      this.close();
    },
    getCases: function() {
      this.isLoading = true;
      this.cases = [];
      axios.get(`${url}/caseManagement/client/${this.clientID}`).then(res => {
        this.cases = res.data.cases
      })
      .finally(() => (this.isLoading = false));
    },

    addCase: function() {
      if(this.validate()){
        var req_body = {
          Date: this.newDate,
          Time: this.newTime,
          Code: this.newCode,
          Location: this.newLocation,
          ServiceProvided: this.newServiceProvided,
          ClientID: this.clientID,
        };

        axios.post(`${url}/caseManagement`, req_body).then((res) => {
          this.getCases();
          if (res.status == 400) {
            res.json().then(function(data) {
              this.msg=true;
              this.text = data.msg;
            });
          }
          this.clear()
          this.msg = true;
          this.text = "The new record has been added successfully.";
        });
        this.close();
    } else {
      this.msg = true;
      this.text="Please fill out all required fields"
    }
    },

    clear(){
      this.newStartDate = moment(new Date()).format("YYYY-MM-DD");
      this.newEndDate= '';
      this.diagnosis= '';
      this.newType = "";
      this.newICDCode= '';
      this.newDiagnosedBy= '';
    },

    selectedCode(item) {
      this.newICDCode = item;
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
